var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 389,
    viewBox: "0 0 323 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7436 370.812L14.7632 374.49C14.3865 374.955 14.3865 375.62 14.7632 376.085L17.7436 379.762L14.0706 376.778C13.6063 376.401 12.9417 376.401 12.4774 376.778L8.80444 379.762L11.7849 376.085C12.1616 375.62 12.1616 374.955 11.7849 374.49L8.80444 370.812L12.4774 373.796C12.9417 374.174 13.6063 374.174 14.0706 373.796L17.7436 370.812Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5479 375.29L13.8997 375.916L13.2739 388.58L12.6482 375.916L0 375.29L12.6482 374.663L13.2739 362L13.8997 374.663L26.5479 375.29Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.373 7L202.915 10.0332C202.604 10.4166 202.604 10.9655 202.915 11.3489L205.373 14.3822L202.344 11.9208C201.961 11.6097 201.412 11.6097 201.03 11.9208L198 14.3822L200.458 11.3489C200.769 10.9655 200.769 10.4166 200.458 10.0332L198 7L201.03 9.4613C201.412 9.77238 201.961 9.77238 202.344 9.4613L205.373 7Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.898 10.962L202.465 11.4787L201.949 21.9239L201.433 11.4787L191 10.962L201.433 10.4452L201.949 0L202.465 10.4452L212.898 10.962Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.375 113.141L312.96 116.12C312.655 116.496 312.655 117.036 312.96 117.412L315.375 120.391L312.399 117.974C312.023 117.668 311.485 117.668 311.109 117.974L308.133 120.391L310.548 117.412C310.853 117.036 310.853 116.496 310.548 116.12L308.133 113.141L311.109 115.558C311.485 115.864 312.023 115.864 312.399 115.558L315.375 113.141Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M322.508 116.767L312.261 117.274L311.754 127.534L311.247 117.274L301 116.767L311.247 116.259L311.754 106L312.261 116.259L322.508 116.767Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M269.751 35.8788L266.875 33L264 35.8788L266.875 38.7576L269.751 35.8788Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M322.751 356.879L319.875 354L317 356.879L319.875 359.758L322.751 356.879Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsMob);
export default __webpack_public_path__ + "static/media/stars-mob.37f5e9f5cee305a8692ea0e5b418d468.svg";
export { ForwardRef as ReactComponent };